/**
 * <TabsSkeleton> — la place d'une rangée d'onglets pendant un chargement : ses libellés en barres de
 * texte, sa hauteur et son écart (`tabsRowMetrics`) et son filet. Le trait de l'onglet ouvert ne se montre pas :
 * on ne sait pas encore lequel l'est.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Skeleton } from "../../atoms/Skeleton"
import { type SpacingKey } from "../../theme/tokens/spacing"
import { tabsRowMetrics } from "./Tabs"

export type TabsSkeletonProps = {
    /** La largeur de chaque libellé, en px. */
    widths: number[]
    size?: "md" | "sm"
}

export function TabsSkeleton(props: TabsSkeletonProps) {
    const { widths, size = "md" } = props
    const { height, gap, text } = tabsRowMetrics(size)
    return (
        <View style={styles.row(height, gap)}>
            {widths.map((width, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Skeleton key={index} textSize={text} width={width} />
            ))}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    row: (height: number, gap: SpacingKey) => ({
        height,
        flexDirection: "row" as const,
        alignItems: "center" as const,
        gap: theme.spacing[gap],
        borderBottomWidth: 1,
        borderBottomColor: theme.colors["border-subtle"],
    }),
}))
